(function () {
  function toNumber(value) {
    var parsed = Number.parseFloat(String(value || '').replace(/,/g, '').trim());
    if (Number.isNaN(parsed) || parsed < 0) {
      return 0;
    }
    return parsed;
  }

  function formatRounded(value) {
    return Math.round(value).toLocaleString('en-US');
  }

  function calculateMonthlyExpense(type, spw, tps, soloPayment, premierPayment) {
    var mp = type === 'premier' ? premierPayment : soloPayment;
    var monthlyExpense = (spw * tps) * 0.1 * 4.3 + (spw * (tps / 30) * 2 * 4.3) + mp;
    return monthlyExpense;
  }

  function initCalculatorV2(root) {
    var scope = root || document;
    var calculators = scope.querySelectorAll('[data-expense-calculator-v2]');

    calculators.forEach(function (calculator) {
      if (calculator.dataset.calculatorV2Ready === 'true') {
        return;
      }
      calculator.dataset.calculatorV2Ready = 'true';

      var configNode = calculator.querySelector('[data-calc2-config]');
      var planToggle = calculator.querySelector('[data-plan-toggle]');
      var soloLabel = calculator.querySelector('[data-plan-label="solo"]');
      var premierLabel = calculator.querySelector('[data-plan-label="premier"]');
      var sessionsInput = calculator.querySelector('input[name="spw"]');
      var timeInput = calculator.querySelector('input[name="tps"]');
      var monthlyInput = calculator.querySelector('[data-monthly-payment]');
      var resultNode = calculator.querySelector('[data-expense-result]');
      var button = calculator.querySelector('[data-calc2-button]');

      if (!planToggle || !sessionsInput || !timeInput || !monthlyInput || !resultNode || !button) {
        return;
      }

      var config = {};
      if (configNode) {
        try {
          config = JSON.parse(configNode.textContent || '{}');
        } catch (_error) {
          config = {};
        }
      }

      var soloPayment = toNumber(config.soloMonthlyPayment || calculator.dataset.soloPayment || 39);
      var premierPayment = toNumber(config.premierMonthlyPayment || calculator.dataset.premierPayment || 59);

      function getCurrentPlanType() {
        return planToggle.checked ? 'premier' : 'solo';
      }

      function syncPlanUI() {
        var planType = getCurrentPlanType();
        var payment = planType === 'premier' ? premierPayment : soloPayment;

        monthlyInput.value = String(Math.round(payment));

        if (soloLabel) {
          soloLabel.classList.toggle('is-active', planType === 'solo');
        }
        if (premierLabel) {
          premierLabel.classList.toggle('is-active', planType === 'premier');
        }
      }

      function calculate() {
        var planType = getCurrentPlanType();
        var spw = toNumber(sessionsInput.value);
        var tps = toNumber(timeInput.value);
        var expense = calculateMonthlyExpense(planType, spw, tps, soloPayment, premierPayment);
        resultNode.textContent = formatRounded(expense);
      }

      planToggle.addEventListener('change', function () {
        syncPlanUI();
        calculate();
      });

      button.addEventListener('click', calculate);

      [sessionsInput, timeInput].forEach(function (input) {
        input.addEventListener('keydown', function (event) {
          if (event.key === 'Enter') {
            event.preventDefault();
            calculate();
          }
        });
      });

      syncPlanUI();
      calculate();
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCalculatorV2(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCalculatorV2(document);
    });
  } else {
    initCalculatorV2(document);
  }
})();
